module.exports = __webpack_public_path__ + "img/20210131_122008.5d1c3777.jpg";